<div class="card" *transloco="let t; read: 'ime.manufacturing.item-log'">
  <div class="card-body">
    <p-table styleClass="p-datatable-sm p-datatable-striped"
             [value]="logs"
             dataKey="Id"
             [lazy]="false"
             [paginator]="false">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">#</th>
          <th scope="col">{{t('Status')}}</th>
          <th scope="col">{{t('Start')}}</th>
          <th scope="col">{{t('End')}}</th>
          <th scope="col">{{t('AssignedTo')}}</th>
          <th scope="col">{{t('Description')}}</th>
          <th scope="col">{{t('Content')}}</th>
          <th scope="col">{{t('CreatedDate')}}</th>
          <th scope="col">{{t('CreatedBy')}}</th>
          <th class="text-end">
            <button class="btn btn-sm btn-outline-primary" (click)="addLog()">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
              {{t('Add')}}
            </button>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr>
          <td class="text-wrap text-break">
            {{logs.length - rowIndex}}
          </td>
          <td class="text-wrap text-break">
            {{classificatorValuesQuery.selectEntity(row.StatusClv) | async | displayName }}
          </td>
          <td class="text-wrap text-break">
            {{row.Start | date: 'short'}}
          </td>
          <td class="text-wrap text-break">
            {{row.End | date: 'short'}}
          </td>
          <td class="text-wrap text-break">
            {{(usersQuery.selectEntity(row.AssignedTo) | async)?.Fullname }}
          </td>
          <td class="text-wrap text-break">
            {{row.Description}}
          </td>
          <td class="text-break text-pre">
            {{row.Content}}
          </td>
          <td class="text-wrap text-break">
            {{row.CreatedDate | date: 'short'}}
          </td>
          <td class="text-wrap text-break">
            {{(usersQuery.selectEntity(row.CreatedBy) | async)?.Fullname }}
          </td>
          <td class="text-end">
            <button class="btn btn-sm btn-outline-primary" (click)="editLog(row)">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

